import React from 'react';
import { Instagram, Facebook, Youtube, ShieldCheck } from 'lucide-react';
import { content } from '../data/content';
import { SunsetBands } from './SunsetBands';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-brown text-brand-cream relative" data-id="element-67">
      <SunsetBands heights={['h-1', 'h-1', 'h-1', 'h-0']} className="absolute top-0 left-0 w-full" data-id="element-68" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 text-center md:text-left" data-id="element-70">
          {/* Brand Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-71">
            <div className="flex items-center gap-3 mb-4" data-id="element-72">
              <img src="https://cdn.magicpatterns.com/uploads/tKwUt9TmjKnTmLiRC8mb2e/hatch-painting-logo.jpg" alt="Hatch Painting logo" className="h-12 w-12 rounded-full object-cover" data-id="element-73" />
              <span className="font-display font-bold text-2xl tracking-wider" data-id="element-74">
                {content.company.wordmark}
              </span>
            </div>
            <p className="text-brand-cream/70 mb-6 max-w-xs" data-id="element-75">
              {content.company.tagline}
            </p>
            <div className="flex items-center text-brand-amber font-medium text-sm bg-brand-cream/10 px-4 py-2 rounded-full" data-id="element-76">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-77" />
              {content.company.roc}
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-78">
            <h4 className="font-bold text-lg mb-6 text-brand-amber" data-id="element-79">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-80">
              <li data-id="element-81">
                <a href="#about" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-82">
                  About
                </a>
              </li>
              <li data-id="element-83">
                <a href="#gallery" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-84">
                  Gallery
                </a>
              </li>
              <li data-id="element-85">
                <a href="#services" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-86">
                  Service Areas
                </a>
              </li>
              <li data-id="element-87">
                <a href="#contact" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-88">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="flex flex-col items-center md:items-start" data-id="element-89">
            <h4 className="font-bold text-lg mb-6 text-brand-amber" data-id="element-90">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-91">
              <li data-id="element-92">
                <a href="#services" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-93">
                  Interior Painting
                </a>
              </li>
              <li data-id="element-94">
                <a href="#services" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-95">
                  Exterior Painting
                </a>
              </li>
              <li data-id="element-96">
                <a href="#services" className="text-brand-cream/70 hover:text-brand-orange transition-colors" data-id="element-97">
                  Renovation Services
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-98">
            <h4 className="font-bold text-lg mb-6 text-brand-amber" data-id="element-99">Contact</h4>
            <ul className="space-y-3 mb-6" data-id="element-100">
              <li data-id="element-101">
                <a href={`tel:${content.company.phone.replace(/[^0-9]/g, '')}`} className="text-brand-cream/70 hover:text-brand-orange transition-colors font-medium" data-id="element-102">
                  {content.company.phone}
                </a>
              </li>
              <li className="text-brand-cream/70" data-id="element-103">
                Serving Gilbert, AZ and surrounding areas
              </li>
            </ul>

            {/* Social Icons */}
            <div className="flex space-x-4" data-id="element-104">
              <a href="#" className="w-10 h-10 rounded-full bg-brand-cream/10 flex items-center justify-center hover:bg-brand-orange transition-colors" data-id="element-105">
                <Instagram className="w-5 h-5" data-id="element-106" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-cream/10 flex items-center justify-center hover:bg-brand-orange transition-colors" data-id="element-107">
                <Facebook className="w-5 h-5" data-id="element-108" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-cream/10 flex items-center justify-center hover:bg-brand-orange transition-colors" data-id="element-109">
                <Youtube className="w-5 h-5" data-id="element-110" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-cream/10 flex items-center justify-center hover:bg-brand-orange transition-colors font-bold text-lg italic" data-id="element-111">
                y
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-brand-cream/10 flex flex-col md:flex-row justify-between items-center text-sm text-brand-cream/50" data-id="element-112">
          <p data-id="element-113">
            &copy; {currentYear} {content.company.name}. All rights reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-114">Managed by LetLois</p>
        </div>
      </div>
    </footer>;
}